export default {
  bind(el, binding, vnode) {
    console.log(vnode)
    el.setAttribute('draggable', 'true');
    el.ondragstart = function (event) {
      event.dataTransfer.setData('text/plain', null); // 不传递数据，仅用于拖拽效果
      binding.value.start && binding.value.start(); // 拖拽开始时的回调
    };
    el.ondragover = function (event) {
      event.preventDefault(); // 允许放置目标接收拖放数据
    };
    el.ondrop = function (event) {
      event.preventDefault(); // 阻止默认处理程序运行
      binding.value.drop && binding.value.drop(); // 放置时的回调
    };
  }    
};